export const blockIconsImageRotateRight = (
	<span className='material-symbols-outlined'>rotate_right</span>
);
